import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 9v12","key":"svg-0"}],["path",{"d":"M8 17l4 4l4 -4","key":"svg-1"}],["path",{"d":"M21 12a9 9 0 0 0 -18 0","key":"svg-2"}]]

const IconArrowUpFromArc = createReactComponent('outline', 'arrow-up-from-arc', 'ArrowUpFromArc', __iconNode);

export default IconArrowUpFromArc;